const BROWSER_RULES: Array<{ name: string; pattern: RegExp }> = [
  { name: "Edge", pattern: /(?:Edg|EdgA|EdgiOS)\/(\d+)/ },
  { name: "Opera", pattern: /(?:OPR|OPiOS)\/(\d+)/ },
  { name: "Samsung Internet", pattern: /SamsungBrowser\/(\d+)/ },
  { name: "Firefox", pattern: /(?:Firefox|FxiOS)\/(\d+)/ },
  { name: "Chrome", pattern: /(?:Chrome|CriOS)\/(\d+)/ },
  { name: "Safari", pattern: /Version\/(\d+)[\d.]*.*Safari\// }
];

export const getBrowserType = (
  userAgent: string = typeof navigator === "undefined"
    ? ""
    : navigator.userAgent
): string => {
  for (const { name, pattern } of BROWSER_RULES) {
    const match = pattern.exec(userAgent ?? "");
    if (match) return `${name} ${match[1]}`;
  }
  return "Unknown";
};
